import { type FC, type PropsWithChildren } from 'react'

interface MeetingInsightsCardProps extends PropsWithChildren {
  title: string
  subtitle: string
  infoBoxTitle?: string
}

export const MeetingInsightsCard: FC<MeetingInsightsCardProps> = ({ title, subtitle, infoBoxTitle, children }) => {
  return (
    <div className='bg-white border zocks-border-0.5 pt-3 pb-4 px-3 d-flex flex-column zocks-gap-1'>
      <div>
        <div className='d-flex align-items-center justify-content-between zocks-py-0.75 w-100'>
          <h5 className='m-0'>{title}</h5>
          <span className='paragraph-small zocks-text-gray-700'>{subtitle}</span>
        </div>
        {infoBoxTitle && <span className='paragraph-small zocks-text-gray-700'>{infoBoxTitle}</span>}
      </div>

      <div className='d-flex flex-column zocks-gap-1 w-100'>{children}</div>
    </div>
  )
}
